import { Link } from '@tanstack/react-router'
import { FileQuestion } from 'lucide-react'

import { Button } from '@/components/ui/button'

export function NotFoundPage() {
  return (
    <div className="flex flex-col items-center gap-3 px-4 py-20 text-center">
      <FileQuestion className="size-7 text-muted" aria-hidden />
      <div className="space-y-1">
        <p className="text-sm font-semibold text-heading">That page does not exist</p>
        <p className="max-w-md text-xs text-muted">
          The address may be mistyped, or the record may belong to a branch you cannot see — the
          server answers both the same way, deliberately.
        </p>
      </div>
      <Button asChild variant="secondary" size="sm">
        <Link to="/">Back to the dashboard</Link>
      </Button>
    </div>
  )
}
